export enum ProfileTypeEnum {
  ON_BEHALF = 'on_behalf_legal_entity',
  LEGAL_ENTITY = 'legal_entity',
  DEPENDENT = 'dependent_legal_entity',
  PERSON = 'person',
}
